'use strict';

namespace Attractions {

    class AttractionsProductForm {

        areaInfo: any;
        stepsData: any[] = [];
        priceData: any = {};
        formModel: any = {};
        totalPrice: number;
        dateLimits: any = {};
        initialised: boolean = false;
        initTimer: ng.IPromise<boolean>;
        loading: boolean = false;
        throttledUpdateTotalPrice: () => void;
        throttledUpdatePrices: () => void;
        infoModal: any = {};
        infoText: any = {};
        normalisedValues: any = {};

        // Attributes
        productId: string;


        constructor (
            private $scope: any,
            private $timeout: ng.ITimeoutService,
            private $routeParams: ng.route.IRouteParamsService,
            private $location: ng.ILocationService,
            private attractionService: any,
            private attractionSearchValidator: any,
            private dateUtil: any,
            private basketService: any,
            private broker: any,
            private modalService: any,
            private Area: any,
            private resourceService: Core.ResourceService,
            private cmsUtils: any
        ) {
            this.areaInfo = Area['attractions'];
            this.fetchCriteria();
            this.dateLimits = {
                startDateMin: this.dateUtil.todayPlus(0, 0, true),
                activeDateFrom: this.dateUtil.todayPlus(7, 0, true)
            };
            this.throttledUpdateTotalPrice = _.throttle(() => this.updateTotalPrice(), 100);
            this.throttledUpdatePrices = _.throttle(() => this.updatePrices(), 100);

            broker.subscribe('attractionsProductForm', 'tabProductOptionSelected',
                e => _.forEach(e.data || {}, (v, k:string) => this.changeField(k, v))
            );

            // Show spinner if delayed
            this.initTimer = $timeout(() => this.loading = true, 1000);

            $scope.$on('$destroy', () => {
                broker.unsubscribe('attractionsProductForm');
            });
        }

        fetchCriteria(): void {
            this.attractionService.getProductFormCriteria(this.productId)
                .then(res => {
                    let qsTags = this.$location.search();
                    if (qsTags) {
                        angular.extend(this.formModel, qsTags);
                    }
                    this.$timeout.cancel(this.initTimer);
                    this.initialised = true;
                    this.loading = false;
                    this.stepsData = res.Steps;

                    if (Array.isArray(this.stepsData)) {
                        this.stepsData.forEach(item => {
                            this.mapNormalisedValues(item);

                            item.Fields.forEach(field => {
                                if (field.Type.toLowerCase() === 'group') {
                                    this.formModel[field.Key] = 1;
                                }
                            });

                            if (item.Info) {
                                this.infoModal[ item.Info.ResourceKey ] = false;
                                this.infoText[ item.Info.ResourceKey ] = {
                                    header: this.resourceService.get( item.Info.ResourceKey + ':HEADER'),
                                    body: this.resourceService.get( item.Info.ResourceKey)
                                };
                            }
                        });
                    }
                });
        }

        setPriceData(key: string, price: string): void {
            this.priceData[key] = {
                price: price
            };
        }

        initField (fieldKey: string, value: any, allowUnknown?: boolean): void {
            // Set initial value, unless already populated
            if (this.formModel[fieldKey] == null) {
                this.changeField(fieldKey, value, allowUnknown);
            }
        }

        changeField (fieldKey: string, value: any, allowUnknown?: boolean): void {
        // NOTE: only allows existing option values unless `allowUnknown` is true
            let isUpdate;
            if (allowUnknown) {
                this.formModel[fieldKey] = value;
                isUpdate = true;
            }
            else {
                const existingVal = this.getMatchedValue(value);
                if (existingVal != null) {
                    this.formModel[fieldKey] = existingVal;
                    isUpdate = true;
                }
            }
            if (isUpdate) {
                this.publishUpdate();
                this.throttledUpdateTotalPrice();
            }
        }

        fieldChangeHandler (affectsPrices: boolean = false): void {
            this.changeField('date', null, true);
            this.publishUpdate();
            if (affectsPrices) {
                this.throttledUpdatePrices();
            }
            else {
                this.throttledUpdateTotalPrice();
            }
        }

        publishUpdate (): void {
            this.broker.publish('attractionsProductUpdate', this.formModel);
        }

        mapNormalisedValues (step): void {
        // Map existing field values for normalised comparison with CMS values
            const map = {};
            const fields = step.Fields || [];
            fields.forEach(field => {
                if (field.Data) {
                    field.Data.forEach(op => {
                        map[this.cmsUtils.normaliseValue(op.Value)] = op.Value;
                    });
                }
            });
            angular.extend(this.normalisedValues, map);
        }

        getMatchedValue (value: any): string {
            return this.normalisedValues[
                    this.cmsUtils.normaliseValue(value)
                ];
        }

        isDateMatch(d1: string = '', d2: string = ''): boolean {
            // Dates may or may not end with '.000Z'
            return d1.split('.')[0] === d2.split('.')[0];
        }

        updatePrices(): void {
            if (this.formModel.date) {
                this.loading = true;

                this.attractionService.getAvailability(
                        this.productId,
                        angular.extend({}, this.formModel)
                    )
                    .then(res => {
                        if (res.error) {
                            this.totalPrice = 0;
                        }
                        else {
                            this.loading = false;
                            res.Dates.forEach(o => {
                                if (this.isDateMatch(o.Date, this.formModel.date)) {
                                    o.Tickets.forEach(d => {
                                        this.setPriceData(d.Key, d.Price);
                                    });
                                }
                            });
                            this.throttledUpdateTotalPrice();
                        }
                    });
            }
        }

        updateTotalPrice (): void {
            let total = 0;
            _.each(this.formModel, (v: any, k: string) => {
                let priceData = this.priceData[k],
                    price = priceData && priceData.price;
                if (price) {
                    total += (price * v);
                }
            });
            this.$scope.$evalAsync(() => {
                this.totalPrice = total;
            });
        }

        book(): void {
            let errors = this.attractionSearchValidator.validate(this.formModel);
            if (errors.length) {
                this.$scope.$emit('flash:error', errors);
            }
            else {
                this.loading = true;
                this.$scope.$emit('flash:hide');

                this.basketService.startWorkflow(this.areaInfo.flow, {
                        productId: this.productId,
                        productTags: this.formModel
                    })
                    .then(lineItems => {
                        this.loading = false;
                        this.modalService.launch('partials/attractions/BasketModal', {
                            lineItems: lineItems,
                            total: this.attractionService.getProductTotals(lineItems).price
                        });
                    });
            }
        }
    }

    angular
        .module('attractions')
        .directive('attractionsProductForm', (): ng.IDirective => {
            return {
                restrict: 'E',
                replace: true,
                scope: {},
                bindToController: {
                    productId: '@' // From CMS
                },
                controller: AttractionsProductForm,
                controllerAs: 'pf',
                templateUrl: 'partials/attractions/productform'
            };
        });
}
